import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RenderType } from 'Shared/app/enums/renderType';
import { Store } from '@ngrx/store';
import * as PatientActions from '../state/patient.actions';
import { WFP_ROUTES } from 'projects/patient/src/app/constants/routes';

@Injectable({
  providedIn: 'root'
})
export class FormRoutingService {
  readonly #router = inject(Router);
  readonly #store = inject(Store);

  public performForm(renderType: RenderType, formId: string, bookedFormId: string) {
    this.#store.dispatch(PatientActions.setActiveForm({ id: bookedFormId }));
    this.#router.navigateByUrl(
      renderType === RenderType.Static ? WFP_ROUTES.STATIC_FORM(bookedFormId) : WFP_ROUTES.DYNAMIC_FORM(bookedFormId)
    );
  }
}
